import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { Table, TableHead, TableBody } from "component/common/Table";
import Pagination from "component/common/Pagination";
import DeleteConfirmation from "component/common/DeleteConfirmation";
import Loader from "component/common/Loader";
import queryString from "query-string";
import dustbin from "assets/images/dustbin.svg";
import styles from "./styles.module.scss";
import { Toast } from "utils/toast";
import { deleteSellerById, getPaymentHistory } from "service/Payment";
import moment from 'moment'

const PaymentHistory = () => {
  let location = useLocation();

  let history = useHistory();

  const historyHeader = [
    "Seller I'd",
    "Name",
    "UPI ID/Bank Account",
    "Product",
    "Total Amount",
    "Sale Date",
    "Payment Date",
    "Payment Status",
  ];

  // const page = new URLSearchParams(location.search).get("page");

  const sellerid = new URLSearchParams(location.search).get("sellerid");

  const sellername = new URLSearchParams(location.search).get("sellername");

  const upi = new URLSearchParams(location.search).get("upi");

  const mobile = new URLSearchParams(location.search).get("mobile");

  const email = new URLSearchParams(location.search).get("email");

  const product = new URLSearchParams(location.search).get("product");

  const amount = new URLSearchParams(location.search).get("amount");

  const sell = new URLSearchParams(location.search).get("sell");

  const paymentStatus = new URLSearchParams(location.search).get(
    "paymentStatus"
  );

  const common = new URLSearchParams(location.search).get("common");

  const [paymentHistoryData, setPaymentHistoryData] = useState();

  let [confirmation, setConfirmation] = useState(false);

  let [id, setId] = useState(null);

  let [totalPages, setTotalPages] = useState(0);
  const [pageMeta,setPageMeta]=useState({
    page:1,
    limit:10,
    totalPages:0
  })

  const getPaymentHistoryFunc = async (page,limit) => {
    let params = {
      page: page != null ? page : 1,
      sellerid: sellerid,
      upi: upi,
      amount: amount,
      common: common,
      limit:limit
    };
    try {
      let response = await getPaymentHistory(params);
      if (response.status == 200) {
        let initialVal = response.data.data;
        setPaymentHistoryData(initialVal);
        let data = {...pageMeta};
        data.totalPages = response.data.data.pageMeta.totalPages;
        data.page=response.data.data.pageMeta.page;
        setPageMeta(data)
        setTotalPages(data.totalPages)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange=(res)=>{
      getPaymentHistoryFunc(res,pageMeta.limit)
  }

  // const handlePageChange = async (event) => {
  //   let params = queryString.stringify({
  //     sellerid: sellerid ? sellerid : undefined,
  //     sellername: sellername ? sellername : undefined,
  //     upi: upi ? upi : undefined,
  //     amount: amount ? amount : undefined,
  //     paymentStatus: paymentStatus ? paymentStatus : undefined,
  //     common: common ? common : undefined,
  //     limit:10
  //   });
  //   if (params == "") {
  //     history.push(`/admin/payments/payment-history/page=${event}`);
  //   } else {
  //     history.push(`/admin/payments/payment-history/page=${event}`);
  //   }
  // };

  const onDelete = async () => {
    try {
      let body = {
        sellerId: id,
      };
      let response = await deleteSellerById(body);
      if (response) {
        toggleConfirmation();
        Toast({
          type: "success",
          message: "Seller has been deleted successfully",
        });
        getPaymentHistoryFunc();
        setId(id);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggleConfirmation = () => {
    setConfirmation(!confirmation);
  };

  const showConfirmation = (id) => {
    setId(id);
    toggleConfirmation();
  };

  useEffect(() => {
    getPaymentHistoryFunc(pageMeta.page,pageMeta.limit);
  }, [location.search]);

  if (paymentHistoryData == null) return <Loader />;

  return (
    <>
      <div className="row mb-2">
        <div className="col-md-6">           
          <div  className={styles.donation_title}>
            <b className="mx-2">Payment History</b>
          </div>
        </div>
      </div>
      <Table>
        <TableHead className={styles.donation_head} head={historyHeader} />
        <TableBody>
          {paymentHistoryData?.data?.length > 0 ? (
            paymentHistoryData.data.map((list, index) => {
              return (
                <tr
                  key={index}
                  className={styles.donation_body}
                  style={{ verticalAlign: "center" }}
                >
                  <td>{list.sellerId_by_user?list.sellerId_by_user:"----"}</td>
                  <td>{list.sellerName}</td>
                  <td>{list.upiId}</td>
                  <td>{list?.product?list.product?.join(" , "):"----"}</td>
                  <td>{list.amount?list.amount:"---"}</td>
                  <td>{list?.sale_date?moment(list.sale_date).format("DD/MM/YYYY"):"----"}</td>
                  <td>{list.paymentDate}</td>
                  <td className="text-capitalize">{list.paymentStatus}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="9" className="no-record">
                No Records Found
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={pageMeta.page != null ? pageMeta.page : 1}
          onPageChange={(res)=>handlePageChange(res)}
        />
      )}
      <DeleteConfirmation
        message="Are you sure to delete this seller?"
        isOpen={confirmation}
        toggle={toggleConfirmation}
        onSubmit={onDelete}
      />
    </>
  );
};

export default PaymentHistory;
